import React, { useState, Fragment, useEffect } from 'react'
import PropTypes from 'prop-types'
import PasswordInput from 'component/PasswordInput'
import TextField from 'component/TextField'
import Button from 'component/Button'
import { PING_URL_LOGIN } from '../../constants/api'


const LoginForm = (props) => {
  const { translate, loginUser, fetchPingIdParameter } = props
  const [usePingId, setUsePingId] = useState(false)

  useEffect(() => {
    fetchPingIdParameter().then((pingIdParameter) => {
      setUsePingId(pingIdParameter === 'true');
    })
  }, [])

  const [loginParams, setLoginParams] = useState({
    dsLogin: '',
    dsPassword: '',
  })

  function handleInputChange(event) {
    const { name, value } = event.target
    setLoginParams({ ...loginParams, [name]: value })
  }

  async function handleSubmit(event) {
    event.preventDefault()
    usePingId
      ? window.location.replace(PING_URL_LOGIN)
      : await loginUser(loginParams)
  }

  return (
    <form className='margin-top-double' onSubmit={handleSubmit}>
      {!usePingId && (
        <Fragment>
          <TextField
            label={translate('newLogin.input.login.label')}
            placeholder={translate('newLogin.input.login.placeholder')}
            required
            name='dsLogin'
            onChange={handleInputChange}
            maxLength={8}
            validateValue={(val) => val && val === 'xxxxx'}
          />
          <PasswordInput
            label={translate('newLogin.input.password.label')}
            placeholder={translate('newLogin.input.password.placeholder')}
            onChange={handleInputChange}
            name='dsPassword'
          />
        </Fragment>
      )}
      <Button
        className='btn-lg btn-primary'
        disabled={
          !usePingId &&
          (!loginParams.dsLogin.length > 0 ||
            !loginParams.dsPassword.length > 0)
        }
        text={translate('newLogin.button.label')}
      />
    </form>
  )
}
LoginForm.propTypes = {
  translate: PropTypes.func.isRequired,
  loginUser: PropTypes.func.isRequired,
  fetchPingIdParameter: PropTypes.func.isRequired,
}

export default LoginForm
